package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.dom.svg.Path
import com.varabyte.kobweb.compose.dom.svg.ViewBox
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.IconRenderStyle
import com.varabyte.kobweb.silk.components.icons.createIcon

/**
 * Broom (Material `cleaning_services`) for the per-column filter's clear-text button.
 *
 * Silk 0.25.1 ships no brush/broom icon, so this follows the library's one-icon-per-file
 * convention to keep the unused icons out of the bundle.
 */
@Composable
internal fun BrushIcon(modifier: Modifier = Modifier) {
    createIcon(
        viewBox = ViewBox(0, 0, 24, 24),
        renderStyle = IconRenderStyle.Fill(),
        attrs = modifier.toAttrs(),
    ) {
        Path {
            d(
                "M16 11h-1V3c0-1.1-.9-2-2-2h-2C9.9 1 9 1.9 9 3v8H8c-2.76 0-5 2.24-5 5v7h18v-7" +
                    "c0-2.76-2.24-5-5-5zm3 10h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1" +
                    "s-1 .45-1 1v3H9v-3c0-.55-.45-1-1-1s-1 .45-1 1v3H5v-5c0-1.65 1.35-3 3-3h8" +
                    "c1.65 0 3 1.35 3 3v5z",
            )
        }
    }
}
